export default class ClearCompositionStore {
  constructor(context) {
    this.context = context;
  }

  run() {
    this.context.stores.snippetComposition.remove();
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/knowledge_base/clear_composition_store.js